import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from "moment";
import { format, startOfMonth, endOfMonth, eachDayOfInterval } from 'date-fns'
import { AnimatePresence } from 'framer-motion';

import { Animation, ListTile, Check } from 'components'
import { Calendar, DateSelector, ToggleButton, UpgradeModal } from 'features'
import { FaAngleUp, FaEdit } from 'react-icons/fa'

import * as actionCreators from 'store/actions'
import { Schedule } from 'schema'
import { itemContext } from 'context'

const Container = styled.div`
    height: calc(100% - 2.5rem);
`

const GridContainer = styled.div`
    display: grid;
    grid-template-columns: 15rem 1fr;
    grid-column-gap: 1rem;
    /* height: 95%; */
    height: calc(100vh - 6rem);
`

const Column = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
`

const SelectContainer = styled.div`
    border-radius: 5px;
    background-color: var(--secondary-color);
    height: min-content;
    margin: 0.5rem 0;
`

const Title = styled.div`
    display: flex;
    height: min-content;
    width: 100%;
    align-items: center;
    cursor: pointer;
    background-color: var(--primary-color);
    padding: 0.2rem;
    border-radius: 5px;
    :hover {
        filter: brightness(var(--brightness));
    }
`

const Wrapper = styled.div`
    overflow-y: ${props => props.overflowY || 'hidden'};
    overflow-x: hidden;
    /* max-height: 10rem; */
`

const GridColumn = styled.div`
    display: grid;
    grid-template-rows: auto auto auto 1fr;
    height: 100%;
    overflow-y: auto;
`

class MonthView extends Component {
    constructor(props){
        super(props);
        this.state = {
            showPages: true,
            showPriority: true,
        }

        this.toggleStyle = {
            backgroundColor: 'transparent',
            padding: '0.3rem', 
            fontSize: '1rem'
        }

        this.tileStyle = {
            backgroundColor: 'var(--primary-color)',
            padding: '0.1rem 0.3rem'
        }
    }

    dateHandler = (date) => {
        this.props.onSelectDate(date)
    }

    renderPriority = () => {
        let elements = []
        Object.values(itemContext.PRIORITY).map(priority => {
            const include = this.props.filters.priorities.includes(priority)
            const text = priority[0] + priority.toLowerCase().slice(1)
            elements.push(
                <ListTile text={text} styles={this.tileStyle} 
                    icon={<Check filled={!!include} margin='0.1rem 0.3rem'
                        backgroundColor={include && itemContext.PRIORITY_COLOR[priority]}
                        borderColor={itemContext.PRIORITY_COLOR[priority]}
                        onSelect={() => {}}/>} 
                    onSelect={() => this.props.onFilter('PRIORITY', itemContext.PRIORITY[priority])}/>
            )
        })
        return elements
    }

    renderPages = () => {
        let elements = []
        const pageIDs = Object.keys(this.props.data['pages'])
        pageIDs.map(pageID => {
            const page = this.props.data['pages'][pageID]
            const text = page['page_name']
            const include = this.props.filters.pageIDs.includes(pageID) & page['status'] === 'ACTIVE'

            elements.push(
                <ListTile text={text} styles={this.tileStyle} 
                    icon={<Check filled={!!include} margin='0 0.3rem'
                            backgroundColor={include && 'var(--secondary-accent-color)'}
                            borderColor='var(--secondary-accent-color)'
                            onSelect={() => {}}/>} 
                    onSelect={() => this.props.onFilter('PAGES', pageID)}/>
            )
        })
        return elements
    }

    render(){
        const selectedDate = this.props.date.clone()
        const calendar = <Calendar view='month' date={this.props.date} events={this.props.events} styles={this.props.styles}
                            onSchedule={this.props.onSchedule}
                            onDrillDown={this.props.onDrillDown}
                            disable={this.props.user['subscription_plan'] === 'PERSONAL'}
                            onDisable={() => this.props.setModal(<UpgradeModal trigger='calendar'/>, 'UpgradeModal')}
                            onSelectEvent={this.props.onSelectEvent}/>
        let element;
        if(this.props.modal){
            element = <Container>{calendar}</Container>
        } else {
            element =
            <GridContainer>
                <Column>
                    <SelectContainer><DateSelector type='date' date={selectedDate} onSelect={this.dateHandler}/></SelectContainer>

                    <GridColumn>
                        {/* Priority filters */}
                        <Title onClick={() => this.setState({showPriority: !this.state.showPriority})}>
                            <div style={{fontSize: '0.9rem', fontWeight: 'bolder', width: '100%', marginLeft: '0.3rem'}}>Priority</div>
                            <ToggleButton open={this.state.showPriority} 
                                styles={this.toggleStyle} 
                                icon={<FaAngleUp/>} end={180}/>
                        </Title>
                        
                        <Wrapper>
                            <AnimatePresence initial={false} key='priority'>
                                {this.state.showPriority && 
                                <Animation animation='expand'>
                                    {this.renderPriority()}
                                </Animation>}
                            </AnimatePresence>
                        </Wrapper>

                        {/* Page filters */}
                        <Title onClick={() => this.setState({showPages: !this.state.showPages})}>
                            <div style={{fontSize: '0.9rem', fontWeight: 'bolder', width: '100%', marginLeft: '0.3rem'}}>Pages</div>
                            <ToggleButton open={this.state.showPages} 
                                styles={this.toggleStyle} 
                                icon={<FaAngleUp/>} end={180}/>
                        </Title>
                        
                        <Wrapper overflowY='auto'>
                            <Wrapper overflowY='auto'>
                                <AnimatePresence initial={false} key='priority'>
                                    {this.state.showPages && 
                                    <Animation animation='expand'>
                                        {this.renderPages()}
                                    </Animation>}
                                </AnimatePresence>
                            </Wrapper>
                        </Wrapper>
                    </GridColumn>

                </Column>

                {calendar}
            </GridContainer>
        }
        return element
    } 
}

const mapStateToProps = state => {
    return {
        uid: state.auth.uid,
        user: state.auth.user,
        data: state.db.present.data && state.db.present.data.toJS(),
        activePageID: state.auth.activePageID,

        window: state.content.window,
        body: state.content.body,

        showAccess: state.content.showAccess,
        access: state.content.access,
        accessProps: state.content.accessProps,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setModal: (element, id) => dispatch(actionCreators.setModal(element, id)),
        setAccess: (showAccess, module, accessProps) => dispatch(actionCreators.setAccess(showAccess, module, accessProps)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(MonthView);